import { Component, Input } from '@angular/core';
import { LoadManagementSearchUnknownCarrierDto } from '../../shared/load-management-search-response';

@Component({
  selector: 'app-bluechat-carriers-unknown',
  templateUrl: './bluechat-carriers-unknown.component.html',
  styleUrls: ['./bluechat-carriers-unknown.component.scss']
})
export class BluechatCarriersUnknownComponent {

  public formattedUnknownCarrierLoads: Array<string>;

  @Input() set unknownCarrierDeliveries(unknownCarrierLoads: LoadManagementSearchUnknownCarrierDto[]) {
    if (unknownCarrierLoads == null) {
      return;
    }

    this.formattedUnknownCarrierLoads = unknownCarrierLoads.map(unknownCarrier =>
      this.getFormattedString(unknownCarrier.name, unknownCarrier.deliveryNumbers)
    );
  }

  private getFormattedString(carrierName: string, deliveryNumbers: Array<string>) {
    let result = ' ';
    result = result.concat(carrierName, ' (');
    return result.concat(deliveryNumbers.join(', '), ')');
  }
}

